// Cutting prose to fit a table cell.
//
// Done in the text rather than with a CSS line clamp: clamping needs
// `display: -webkit-box`, which a table cell cannot be without taking the
// column widths with it, and the result was prose sliced through the middle of
// a line with nothing to say it had been.

const SUMMARY_CHARS = 240

export function shorten(text: string, limit: number = SUMMARY_CHARS): string {
  if (text.length <= limit) return text

  // Back up to a word boundary so the cut lands between words, not inside one.
  const cut = text.slice(0, limit)
  const lastSpace = cut.lastIndexOf(" ")
  const kept = lastSpace > limit * 0.6 ? cut.slice(0, lastSpace) : cut
  return `${kept.replace(/[.,;:\s]+$/, "")}…`
}
